import React, { Component } from "react";
import { connect } from "react-redux";
import { resetPasswordCustomer } from "../../store/actions/customer";
import PageTitle from "../../components/shared/PageTitle";
import styles from "../../thema/style";

class ResetPassword extends Component {
  state = {
    errors: [],
    email: "",
    password: ""
  };

  renderErrorMessage() {
    if (this.props.customer.resetPassword === true) {
      return (
        <div
          className="alert alert-success"
          role="alert"
          style={{ marginTop: 20 }}
        >
          <h4 className="alert-heading">Şifreniz Sıfırlandı!</h4>
          <p>
            Şifreniz başarıyla sıfırlandı. Yeni şifreniz ile giriş
            yapabilirsiniz.
          </p>
        </div>
      );
    }
    if (
      this.props.customer.resetPasswordError &&
      this.props.customer.resetPasswordError.length > 0
    ) {
      return (
        <div
          className="alert alert-danger"
          role="alert"
          style={{ marginTop: 20 }}
        >
          <h4 className="alert-heading">Hata Meydana Geldi!</h4>
          <p>
            <ul>
              {this.props.customer.resetPasswordError.map((error, i) => (
                <li key={i}>{error.message}</li>
              ))}
            </ul>
          </p>
        </div>
      );
    }

    if (this.state.errors.length > 0) {
      return (
        <div
          className="alert alert-danger"
          role="alert"
          style={{ marginTop: 20 }}
        >
          <h4 className="alert-heading">Hata Meydana Geldi!</h4>
          <p>
            <ul>
              {this.state.errors.map((error, i) => <li key={i}>{error}</li>)}
            </ul>
          </p>
        </div>
      );
    } else {
      return null;
    }
  }

  validate = () => {
    const errors = [];
    if (!this.state.email) errors.push("E-Mail alanı boş bırakılamaz!");
    if (!this.state.password) errors.push("Şifreniz alanı boş bırakılamaz!");
    if (this.state.password && this.state.password.length < 6) errors.push("Şifreniz en az 6 karakter olmalıdır!");
    return errors;
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = e => {
    e.preventDefault();
    var errors = this.validate();
    this.setState({ errors: errors });
    if (errors.length === 0) {
      this.props.resetPasswordCustomer({
        ...this.state,
        ...this.props.match.params
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <PageTitle title={"Şifremi Sıfırla"} />
        <div className="row">
          <div className={"col-md-6 offset-md-3"}>
            <div className={styles.loginBox}>
              <div className={"overlay-content"} />
              <div className={"tab-content"}>
                <h3>Şifremi Sıfırla</h3>
                {!this.props.customer.resetPassword && (
                  <form onSubmit={this.onSubmit}>
                    <div className={"clearfix large_form"}>
                      <input
                        type="email"
                        name="email"
                        placeholder="E-mail Adresiniz"
                        defaultValue={this.state.email}
                        onChange={e => {
                          this.handleChange(e);
                        }}
                        required
                      />
                    </div>
                    <div className={"clearfix large_form"}>
                      <input
                        type="password"
                        name="password"
                        placeholder="Şifreniz"
                        onChange={e => {
                          this.handleChange(e);
                        }}
                        required
                      />
                    </div>

                    <div className={"clearfix large_form text-left"}>
                      <button
                        disabled={this.props.customer.resetPasswordFetching}
                        style={
                          this.props.customer.resetPasswordFetching
                            ? { opacity: 0.5 }
                            : {}
                        }
                        type="submit"
                      >
                        {this.props.customer.resetPasswordFetching
                          ? "BEKLEYİNİZ..."
                          : "ŞİFREMİ SIFIRLA"}
                      </button>
                    </div>
                  </form>
                )}
                {this.renderErrorMessage()}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ customer }) => {
  return { customer };
};

const mapDispatchToProps = { resetPasswordCustomer };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);



// WEBPACK FOOTER //
// ./src/routers/Forgot/reset.js